import { Col, Row, TitleText, UtilityText } from '@policygenius/mortar';
import classnames from 'classnames';
import React from 'react';

import styles from './navigator-content.module.scss';
import { NavigatorContentProps } from './types';

const NavigatorContent = ({ children, className, heading, subHeading }: NavigatorContentProps) => (
  <Row as="main" className={classnames(styles.wrapper, className)}>
    {!!(heading || subHeading) && (
      <Col
        className={styles.header}
        push={{ medium: 2, large: 3 }}
        span={{ small: 4, medium: 8, large: 6 }}
      >
        {!!heading && (
          <TitleText as="h1" size="large">
            {heading}
          </TitleText>
        )}
        {!!subHeading && (
          <UtilityText size="medium" className={styles.subheader}>
            {subHeading}
          </UtilityText>
        )}
      </Col>
    )}
    <>{children}</>
  </Row>
);

export default NavigatorContent;
